import React from 'react';

/**
 * Location — facts left, embedded Google map right. Auto-numbered when
 * inside `.numbered-sections`.
 */
export default function Location() {
  const facts = [
    ['Hauptsitz', 'Königstein im Taunus'],
    ['Mandate', 'Rhein-Main-Gebiet'],
    ['Termine', 'Vor Ort oder per Videocall'],
    ['Erreichbarkeit', 'Werktags 9 – 19 Uhr'],
  ];

  return (
    <section style={{ padding: '140px 0', background: 'var(--cream-deep)' }}>
      <div className="shell">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1.1fr',
            gap: 80,
            alignItems: 'stretch',
          }}
        >
          <div className="reveal">
            <div className="section-label numbered" style={{ marginBottom: 28 }}>
              <span>Wo Sie uns finden</span>
            </div>
            <h2 className="h-section" style={{ marginBottom: 32, maxWidth: '16ch' }}>
              Unsere Büroräume im Taunus
            </h2>
            <p className="body-prose" style={{ fontSize: 18, marginBottom: 40 }}>
              Unser Büro liegt in einer Jugendstilvilla in Königstein im Taunus. Von hier betreut die hamba GmbH Objekte im gesamten Rhein-Main-Gebiet und in Bayern. Wir freuen uns immer über den persönlichen Kontakt mit unseren Kunden — Sie sind also jederzeit herzlich willkommen!
            </p>

            <dl
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: 0,
                borderTop: '1px solid var(--cream-line)',
              }}
            >
              {facts.map(([k, v], i) => (
                <div
                  key={i}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '160px 1fr',
                    gap: 24,
                    padding: '16px 0',
                    borderBottom: '1px solid var(--cream-line)',
                    alignItems: 'baseline',
                  }}
                >
                  <dt
                    style={{
                      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                      fontSize: 11,
                      letterSpacing: '0.14em',
                      color: 'var(--charcoal-muted)',
                      textTransform: 'uppercase',
                    }}
                  >
                    {k}
                  </dt>
                  <dd
                    style={{
                      fontFamily: 'var(--serif)',
                      fontSize: 19,
                      color: 'var(--anthracite)',
                    }}
                  >
                    {v}
                  </dd>
                </div>
              ))}
            </dl>

            <div style={{ marginTop: 36, fontSize: 14, lineHeight: 1.7, color: 'var(--charcoal)' }}>
              <strong>hamba GmbH</strong><br />
              Villa Regina <br />
              Limburger Str. 17<br />
              61462 Königstein im Taunus
            </div>
          </div>

          <div
            className="reveal"
            style={{
              position: 'relative',
              minHeight: 460,
              background: 'var(--cream)',
              border: '1px solid var(--cream-line)',
              overflow: 'hidden',
            }}
          >
            <iframe
              title="hamba GmbH · Limburger Str. 17, Königstein im Taunus"
              src="https://www.google.com/maps?q=Limburger+Str.+17,+61462+K%C3%B6nigstein+im+Taunus,+Germany&z=15&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 0,
                display: 'block',
                filter: 'grayscale(0.25) contrast(0.95)',
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
